import React, { Component } from 'react';
import classes from './Slider.module.css';

class Slider extends Component {
    state = {
        min: 1,
        max: 100,
        value: this.props.brushSize
    }

    valueChangeHandler = (event) => {
        this.setState({ value: event.target.value }, () => {
            this.props.getSliderValueHandler(this.state.value)
        })
    }

    render() {
        return (
            <input type="range" min={this.state.min} max={this.state.max} value={this.state.value} className={classes.slider} onChange={(event) => this.valueChangeHandler(event)} />
        )
    }
}

export default Slider;